// extracted by mini-css-extract-plugin
module.exports = {"title":"onboarding_title__2KFps","titleIcon":"onboarding_titleIcon__2kqWZ"};